var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseHamburger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Wireframe / UI elements / Icons / x-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "For-Brock---MVP-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sibebar_-mob",
    transform: "translate(-392, -79)",
    fill: "#A8A8A8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wireframe-/-UI-elements-/-Icons-/-x-icon",
    transform: "translate(392, 79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.41392776,7.99998438 L15.7070195,1.70758007 C16.0976602,1.31693946 16.0976602,0.683589817 15.7070195,0.292980457 C15.3163789,-0.0976601523 14.6830293,-0.0976601523 14.2924199,0.292980457 L14.2924199,0.292980457 L7.99998438,6.58604099 L1.70758007,0.292980457 C1.31693946,-0.0976601523 0.683589817,-0.0976601523 0.292980457,0.292980457 C-0.0976289035,0.683621066 -0.0976601523,1.31697071 0.292980457,1.70758007 L6.58604099,7.99998438 L0.292980457,14.2924199 C-0.0976601523,14.6830605 -0.0976601523,15.3164102 0.292980457,15.7070195 C0.683621066,16.0976289 1.31697071,16.0976602 1.70758007,15.7070195 L7.99998438,9.41392776 L14.2923887,15.7070195 C14.6830293,16.0976602 15.3163789,16.0976602 15.7069883,15.7070195 C16.0976289,15.3163789 16.0976289,14.6830293 15.7069883,14.2924199 L9.41392776,7.99998438 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseHamburger);
export default __webpack_public_path__ + "static/media/closeHamburger.70cfef7fef16f55f35de0a200dd37326.svg";
export { ForwardRef as ReactComponent };